import { z } from 'zod';
import { Locale, UserStatus } from '../enums.js';

export const CreateUserSchema = z.object({
  email: z.string().email().max(120).transform((s) => s.trim().toLowerCase()),
  fullName: z.string().min(2).max(120),
  phone: z.string().min(8).max(20).optional(),
  password: z.string().min(8).max(128),
  roleId: z.string().uuid(),
  locale: z.enum(Locale).default('AR'),
});
export type CreateUser = z.infer<typeof CreateUserSchema>;

export const UpdateUserSchema = z.object({
  fullName: z.string().min(2).max(120).optional(),
  phone: z.string().min(8).max(20).nullable().optional(),
  roleId: z.string().uuid().optional(),
  locale: z.enum(Locale).optional(),
  status: z.enum(UserStatus).optional(),
});
export type UpdateUser = z.infer<typeof UpdateUserSchema>;

export const ResetPasswordSchema = z.object({ newPassword: z.string().min(8).max(128) });
export type ResetPassword = z.infer<typeof ResetPasswordSchema>;

export const CreateRoleSchema = z.object({
  code: z
    .string()
    .min(2)
    .max(40)
    .regex(/^[A-Z0-9_]+$/, 'UPPER_SNAKE_CASE'),
  nameAr: z.string().min(2).max(80),
  nameEn: z.string().min(2).max(80),
  permissions: z.array(z.string()).default([]),
});
export type CreateRole = z.infer<typeof CreateRoleSchema>;

export const UpdateRoleSchema = CreateRoleSchema.omit({ code: true }).partial();
export type UpdateRole = z.infer<typeof UpdateRoleSchema>;
